module.exports = __webpack_public_path__ + "media/modals/close-bad6901f.svg";